import React from 'react';
import { observer } from 'mobx-react';
import BeatLoader from 'react-spinners/BeatLoader';
import classnames from 'classnames';
import styled from 'styled-components';

import { COLORS } from 'shared/constants';

import './styles.scss';

type PropsType = {
    onClick?: (event: React.SyntheticEvent) => void;
    className?: string;
    style?: {
        color?: [string, string];
        backgroundColor?: [string, string];
        borderColor?: [string, string];
    } & Omit<React.CSSProperties, 'color' | 'backgroundColor' | 'borderColor'>;
    children?: React.ReactNode;
    type?: 'submit' | 'reset' | 'button';
    isLoading?: boolean;
    isDisabled?: boolean;
    template?: 'large' | 'small' | 'base' | 'medium' | 'link' | 'icon';
};

const Button = styled.button<{
    $color?: string;
    $colorHover?: string;
    $backgroundColor?: string;
    $backgroundColorHover?: string;
    $borderColor?: string;
    $borderColorHover?: string;
}>`
    ${({ $color }) => ($color ? `color: ${$color}!important;` : '')}
    ${({ $backgroundColor }) => ($backgroundColor ? `background-color: ${$backgroundColor}!important;` : '')}
    ${({ $borderColor }) => ($borderColor ? `border: 1px solid ${$borderColor}!important;` : '')}
    &:hover {
        ${({ $colorHover }) => ($colorHover ? `color: ${$colorHover}!important;` : '')}
        ${({ $backgroundColorHover }) => ($backgroundColorHover ? `background-color: ${$backgroundColorHover}!important;` : '')}
        ${({ $borderColorHover }) => ($borderColorHover ? `border: 1px solid ${$borderColorHover}!important;` : '')}
    }
`;

export const UiButton = observer(function UiButton({
    isDisabled = false,
    template = 'base',
    className = '',
    style = {},
    onClick,
    isLoading = false,
    children,
    type = 'button',
}: PropsType) {
    const { color = [COLORS._FFFFFF, COLORS._858991], backgroundColor = [COLORS._2C2F35, COLORS._2C2F35], borderColor, ...styles } = style;

    return (
        <Button
            $color={color[0]}
            $colorHover={color[1]}
            $backgroundColor={backgroundColor[0]}
            $backgroundColorHover={backgroundColor[1]}
            $borderColor={borderColor ? borderColor[0] : undefined}
            $borderColorHover={borderColor ? borderColor[1] : undefined}
            onClick={isDisabled ? undefined : onClick}
            className={classnames('ui-new-button', className, `ui-new-button--${template}`, {
                'ui-new-button--disabled': isDisabled,
            })}
            style={styles}
            type={type}
        >
            {isLoading ? <BeatLoader color={color[0]} size={10} /> : children}
        </Button>
    );
});
